module.exports = __webpack_public_path__ + "img/pr-12.65a7c176.png";